import { ForecastTimelineFilterProperty } from '@/coreDomainsModule/entities/filter';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { ICustomerForecastRepository } from '@/coreInfrastructureModule/interfaces/ICustomerForecastRepository';
import { GetBaseBusinessIdAdapter } from '../adapter/getBaseBusinessIdAdapter';
import { FilterFactory } from '@/coreDomainsModule/factories/filterFactory';
import { ICustomerForecastDiffLastMonthBusinessData } from '../domains/entities/customerForecastDiffLastMonth';
import { GetCustomerForecastTimelineFilterItemsAdapter } from '../adapter/getCustomerForecastTimelineFilterItemsAdapter';

/**
 * 関連取引IDからフィルタ項目を取得するユースケース
 */
export class GetCustomerForecastTimelineFilterItemsUseCase {
  /**
   * フィルタ項目を取得する
   * @param repository - リポジトリ
   * @param baseBusinessId - 関連取引ID
   */
  public async Execute(
    repository: ICustomerForecastRepository,
    baseBusinessId: string
  ): Promise<INetworkResult<ICustomerForecastDiffLastMonthBusinessData, Error>> {
    try {
      const result = await repository.getFilterItems(baseBusinessId);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      const filterItems = GetCustomerForecastTimelineFilterItemsAdapter.adapt(result.status.data);

      return {
        status: {
          type: 'success',
          data: filterItems,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
